(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/init.js'); 
'use strict';

svs.competition.core.logger = svs.core.log.getLogger(
  'component:competition-core'
);

svs.competition.core.userHasPlayedCurrentDraw = function() {
  if (
    svs.utils.ns.isNamespace('svs.competition.core.data.participatedSMDraws') &&
    svs.utils.ns.isNamespace(
      'svs.competition.core.data.tipsSMCompetition.tipsSMDetails.currentDraw'
    )
  ) {
    for (
      var i = 0;
      i < svs.competition.core.data.participatedSMDraws.length;
      ++i
    ) {
      if (
        svs.competition.core.data.participatedSMDraws[i] ===
        svs.competition.core.data.tipsSMCompetition.tipsSMDetails.currentDraw
      ) {
        return true;
      }
    }
  }

  return false;
};

svs.competition.Helper = (function() {
  var userCompetitions, participatedDraws;
  if (
    svs.utils.ns.isNamespace('svs.competition.core.data.competitions', this) &&
    svs.competition.core.data.competitions.length
  ) {
    userCompetitions = svs.competition.core.collections.userCompetitions = new svs.competition.core.collections.UserCompetitions();
    participatedDraws = new svs.competition.core.collections.ParticipatedDraws(
      null,
      {
        competitionId: svs.utils.ns.isNamespace(
          'svs.competition.core.data.tipsSMCompetition',
          this
        )
          ? svs.competition.core.data.tipsSMCompetition.id
          : null,
        participatedDraws: svs.utils.ns.isNamespace(
          'svs.competition.core.data.participatedSMDraws',
          this
        )
          ? svs.competition.core.data.participatedSMDraws
          : null
      }
    );
  }

  function userIsParticipatingInTipsSM() {
    var activeTipsSM = svs.utils.ns.isNamespace(
      'svs.competition.core.data.tipsSMCompetition'
    )
      ? svs.competition.core.data.tipsSMCompetition
      : null;
    if (userCompetitions && userCompetitions.length && activeTipsSM) {
      return (
        userCompetitions.where({
          id: activeTipsSM.id
        }).length > 0
      );
    }
    return false;
  }

  function userHasPlayedDraw(drawNum) {
    if (drawNum) {
      return participatedDraws.userHasPlayedDraw(drawNum);
    }

    return false;
  }

  function userHasPlayedCurrentDraw() {
    if (
      svs.utils.ns.isNamespace(
        'svs.competition.core.data.currentDraw.drawNumber'
      )
    ) {
      return participatedDraws.userHasPlayedDraw(
        svs.competition.core.data.currentDraw.drawNumber
      );
    }

    return false;
  }

  function drawIsValidForTipsSM(drawNum) {
    var activeTipsSM = svs.utils.ns.isNamespace(
      'svs.competition.core.data.tipsSMCompetition'
    )
      ? svs.competition.core.data.tipsSMCompetition
      : null;
    if (activeTipsSM) {
      return (
        drawNum >= activeTipsSM.tipsSMDetails.firstDrawNumber &&
        drawNum <=
          activeTipsSM.tipsSMDetails.firstDrawNumber +
            activeTipsSM.tipsSMDetails.numDraws -
            1
      );
    }
    return false;
  }

  function getCompetitionById(id) {
    if (svs.competition.core.data.competitions) {
      id = _.isString(id) ? parseInt(id, 10) : id;
      return _.findWhere(svs.competition.core.data.competitions, { id: id });
    }
    return null;
  }

  return {
    userCompetitions: userCompetitions,
    getUserCompetitions: function() {
      return userCompetitions;
    },
    userHasPlayedDraw: userHasPlayedDraw,
    userHasPlayedCurrentDraw: userHasPlayedCurrentDraw,
    userIsParticipatingInTipsSM: userIsParticipatingInTipsSM,
    drawIsValidForTipsSM: function(drawNum) {
      return drawIsValidForTipsSM(drawNum);
    },
    getCompetitionById: getCompetitionById
  };
})();

 })(window);